export const CACHE_KEY = "dolphin_venues_cache";
export const CACHE_DURATION_MS = 24 * 60 * 60 * 1000;